import { render, staticRenderFns } from "./examinesocial.vue?vue&type=template&id=fad08f0c&scoped=true&"
import script from "./examinesocial.vue?vue&type=script&lang=js&"
export * from "./examinesocial.vue?vue&type=script&lang=js&"
import style0 from "./examinesocial.vue?vue&type=style&index=0&id=fad08f0c&prod&lang=scss&scoped=true&"
import style1 from "./examinesocial.vue?vue&type=style&index=1&id=fad08f0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad08f0c",
  null
  
)

export default component.exports